export default function () {
    return (
        <svg width="36" height="37" viewBox="0 0 36 37" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_2740_19274)">
                <path
                    d="M14.625 30.875V7.125C14.625 6.57272 14.1773 6.125 13.625 6.125C9.20672 6.125 5.625 9.70672 5.625 14.125V29.1875C5.625 30.1195 6.38052 30.875 7.3125 30.875H14.625Z"
                    stroke="black"
                    strokeWidth="1.6875"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M30.375 23.8438C30.841 23.8438 31.2188 23.466 31.2188 23C31.2188 22.534 30.841 22.1562 30.375 22.1562V23V23.8438ZM27 23V23.8438H30.375V23V22.1562H27V23Z"
                    fill="black"
                />
                <path
                    d="M27 12.875L27 11.75C27 9.26472 24.9853 7.25 22.5 7.25L14.625 7.25L14.625 12.875L27 12.875Z"
                    stroke="black"
                    strokeWidth="1.6875"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M24.75 16.25L24.75 12.875L20.25 12.875L20.25 16.25L24.75 16.25Z"
                    stroke="black"
                    strokeWidth="1.6875"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M27 23.5625L27 21.875L19.125 21.875L19.125 23.5625C19.125 25.7371 20.8879 27.5 23.0625 27.5C25.2371 27.5 27 25.7371 27 23.5625Z"
                    stroke="black"
                    strokeWidth="1.6875"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14.625 30.875L29.7 30.875C30.0728 30.875 30.375 30.5728 30.375 30.2C30.375 28.7088 29.1662 27.5 27.675 27.5L14.625 27.5L14.625 30.875Z"
                    stroke="black"
                    strokeWidth="1.6875"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </g>
            <defs>
                <clipPath id="clip0_2740_19274">
                    <rect width="36" height="36" fill="white" transform="translate(0 0.5)" />
                </clipPath>
            </defs>
        </svg>
    );
}
